

import {errorObjs} from '../CommonObj'
export const AddAndUpdateWorks = {
  formId: "AddAndUpdateWorks",
  formInp: [
    {
      inp: {
        InputLabelProps: {
          shrink: true,
        },
        type: "text",
        label: "Work title",
        name: "title",
        id: "title",
        required: true,
        fullWidth: true,
        helperText: errorObjs,
      },
      grid: 12,
    },
    {
      inp: {
        InputLabelProps: {
          shrink: true,
        },
        type: "text",
        label: "Work link",
        name: "link",
        id: "link",
        rows: 6,
        required: true,
        fullWidth: true,
        helperText: errorObjs,
      },
      grid: 12,
    },
    {
      inp: {
        InputLabelProps: {
          shrink: true,
        },
        type: "text",
        label: "Work description",
        name: "description",
        id: "description",
        rows: 6,
        multiline: true,
        fullWidth: true,
        helperText: errorObjs,
      },
      grid: 12,
    },
    {
      inp: {
        hidden: true,
        type: "file",
        accept: "image/*",
        label: "Choose work image",
        name: "image",
        id: "raised-button-file",
        helperText: errorObjs,
        required: true,
      },
      grid: 12,
    },

    {
      inp: {
        type: "alert",
      },
      grid: 12,
    },
    {
      inp: {
        type: "submit",
        label: "Add works",
        editLabel: "Update work",
        loaderLabel: "Adding data...",
        name: "add",
        id: "add",
        variant: "contained",
        className: "btn-std1",
        fullWidth: true,
        service: {
          schema: "worksSchema",
          editUrl:process.env.REACT_APP_API_SERVICE_URL + `api/update_data`,
          url: process.env.REACT_APP_API_SERVICE_URL + `api/add_data`,
          method: "POST",
        },
      },
      grid: 12,
    },
  ],
};
